import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { StatusBadge } from "./GameBadges";

export function GameSettings({ game }) {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader className="card-header-flight-deck">
            <CardTitle>{t("instructor.gameConfig")}</CardTitle>
          </CardHeader>
          <CardContent className="pt-6 space-y-4">
            <div className="flex justify-between">
              <span className="text-slate-600">{t("admin.maxTeams")}</span>
              <span className="font-mono font-medium">{game.max_teams}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">{t("admin.quarters")}</span>
              <span className="font-mono font-medium">{game.quarters_count}</span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="card-header-flight-deck">
            <CardTitle>{t("admin.status")}</CardTitle>
          </CardHeader>
          <CardContent className="pt-6 space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-slate-600">{t("admin.status")}</span>
              <StatusBadge status={game.status} />
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">{t("admin.quarter")}</span>
              <span className="font-mono font-medium">{game.current_quarter}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">{t("admin.created")}</span>
              <span className="text-sm text-slate-500">{new Date(game.created_at).toLocaleDateString()}</span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
